import {
  PERSON_RECEIVE,
  PERSON_ERROR,
  PERSON_CHANGE_MODE,
  ADDRESS_RECEIVE,
  ADDRESS_ERROR,
  ADDRESS_CHANGE_MODE,
  ORDER_RECEIVE,
  ORDER_ERROR,
  ORDER_CHANGE_MODE,
  ORDER_CHANGE_CURRENTPAGE,
  ORDER_SET_ORDER,
} from '../constants';
import { person as personReducer } from './Person.reducer';
import { address as addressReducer } from './Address.reducer';
import {
  DEFAULT_STATE as DEFAULT_ORDER_STATE,
  order as orderReducer,
  ORDER_STATE,
} from './Order.reducer';
import Address from '../Types/Address';
import { AnyAction } from 'redux';

interface MyPageState {
  persons: any;
  addresses: any;
  orders: ORDER_STATE;
}

const DEFAULT_STATE: MyPageState = {
  persons: {},
  addresses: {},
  orders: DEFAULT_ORDER_STATE,
};

export const myPage = (
  state = DEFAULT_STATE,
  action: AnyAction
): MyPageState => {
  const { type, payload } = action;
  switch (type) {
    case PERSON_RECEIVE:
    case PERSON_ERROR:
    case PERSON_CHANGE_MODE:
      return {
        ...state,
        persons: personReducer(state.persons, action),
      };
    case ADDRESS_RECEIVE:
    case ADDRESS_ERROR:
    case ADDRESS_CHANGE_MODE:
      return {
        ...state,
        addresses: addressReducer(state.addresses, action),
      };
    case ORDER_RECEIVE:
    case ORDER_ERROR:
    case ORDER_CHANGE_MODE:
    case ORDER_CHANGE_CURRENTPAGE:
    case ORDER_SET_ORDER:
      return {
        ...state,
        orders: orderReducer(state.orders, action),
      };
    default:
      return state;
  }
};
